import { useEffect, useState } from 'react';
import { apiHolder, apis } from 'api';
import { useAppDispatch } from '@web-common/state/createStore';
import { actions as LoginActions } from '@web-common/state/reducer/loginReducer';
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
export function useGetOrgInfo() {
    const [orgInfo, setOrgInfo] = useState({
        org_name: '',
        sirius_flag: 0,
        sys_type: 0,
    });
    const dispatch = useAppDispatch();
    useEffect(() => {
        accountApi.doGetOrgInfo().then((res) => {
            if (res) {
                setOrgInfo(res);
                dispatch(LoginActions.setOrgInfo(res));
            }
        });
    }, []);
    return {
        orgInfo,
    };
}
